import { Component, OnInit, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, FormArray, Validators, UntypedFormBuilder } from '@angular/forms';

import { ApiCode } from '../../api-client-module';
import { ProjectLanguage } from '../../firestore-models/project-language';

import { ConfigurationService } from '../../configuration.service';
import { TranslateService } from '@ngx-translate/core';

export interface MultiCodeDialogData {
  codes?: ApiCode[];
}

@Component({
  selector: 'app-multi-youtube-dialog',
  templateUrl: './multi-youtube-dialog.component.html',
  styleUrls: ['./multi-youtube-dialog.component.css'],
  standalone: false,
})
export class MultiYoutubeDialogComponent implements OnInit {

  //名称×言語数
  codes: ApiCode[] = [];
  codesFormGroup!: FormGroup;
  codesArrayControl!: FormArray;
  projectLanguages!: Array<ProjectLanguage>;

  currentLang: string = 'ja';
  projectBaseLang: string = 'ja';

  constructor(
    public dialogRef: MatDialogRef<MultiYoutubeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MultiCodeDialogData,
    private formBuilder: UntypedFormBuilder,
    private configurationService: ConfigurationService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.codes = this.data.codes!;
    if (!this.codes) {
      this.codes = [];
    }
    this.createForm();
    this.codesArrayControl = this.codesFormGroup.get('codes') as FormArray;
    this.currentLang = this.translate.currentLang;
    this.projectBaseLang = this.configurationService.getProject().project_base_lang!;
    //プロジェクト基本言語が管理画面の言語と異なる場合、編集不可にする
    if ((this.currentLang == 'en' && this.projectBaseLang == 'ja') || (this.currentLang == 'ja' && this.projectBaseLang != 'ja')) {
      this.codesFormGroup.disable();
    }
  }

  //埋め込みコードフォーム×言語数
  private createForm() {
    let arrayControl = this.formBuilder.array([]);
    let index: number = 0;
    for (const projectLanguage of this.projectLanguages) {
      let code = '';
      for (const value of this.codes) {
        if (projectLanguage.lang_code === value.lang_code) {
          code = value.code;
          break
        }
      }
      let _dict = {};
      if (index === 0) {
        _dict = {
          code: [code, [Validators.required]],
        }
      } else {
        _dict = {
          code: [code],
        }
      }
      arrayControl.push(this.formBuilder.group(_dict));
      index++;
    }
    this.codesFormGroup = this.formBuilder.group(
      {
        codes: arrayControl
      }
    );
  }

  //更新ボタン
  addCodes(): void {
    if (this.codesFormGroup.valid) {
      let codes = [];
      for (const index in this.projectLanguages) {
        const ctrl = this.codesArrayControl.controls[index];
        codes.push(
          {
            lang_code: this.projectLanguages[index].lang_code,
            code: ctrl.get('code')!.value,
          }
        )
      }
      this.codes = codes;
      this.dialogRef.close(this.codes);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
